import React from "react"
import { FavoriteInternWrapp } from "./FavoriteIntern.style"
import FavoriteInternCard from "./components/card/FavoriteInternCard"
import { getNewVacancy } from "../../../../api/Api"
import { useState } from "react"
import { useEffect } from "react"
import ReactLoading from 'react-loading'

const FavoriteIntern = () => {
  const [newVacancy, setNewVacancy] = useState()
  const [error, setError] = useState(false)

  useEffect(() => {
    getNewVacancy()
      .then(res => res.json())
      .then(res => setNewVacancy(res.ListOfVacancies))
      .catch(err => {
        console.error('Error fetching vacancies:', err)
        setError(true)
      })
  }, [])


  return (
    <FavoriteInternWrapp>
      <div className="container">
        <div className="favorite-intern">
          <h1 className="title">Featured Internships</h1>
          <p className="subtitle">Discover top opportunities from leading companies</p>
          <div className="favintern-card-container">
            {error ? (
              <p className="error-message">Unable to load internships. Please try again later.</p>
            ) : !newVacancy ? (
              <div className="spin-load">
                <ReactLoading type="bubbles" color="#5f7967" height={44} width={44} />
              </div>
            ) : newVacancy?.filter((res, idx) => idx < 3).map((res, idx) => (
              <div key={res.id || idx} data-aos="fade-up" data-aos-offset="10" data-aos-delay={idx * 100}>
                <FavoriteInternCard vacancy={res} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </FavoriteInternWrapp>
  )
}

export default FavoriteIntern
